import React from 'react';
import { useParams } from 'react-router-dom';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const SalesStatusList = () => {
  const { customerId } = useParams();

  const fetchUrl = customerId
    ? `${API_DOMAIN}${API_ROUTES.salesStatus}?customer=${customerId}`
    : `${API_DOMAIN}${API_ROUTES.salesStatus}`;

  const columns = [
    { label: 'Status Description', value: 'status_description' },
    { label: 'Updated At', value: (item) => fmtDateTime(item.updated_at) },
    { label: 'Customer', value: item => item.customer?.name || 'N/A' },
    { label: 'Stage', value: item => item.stage?.name || 'N/A' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/sales-status/details/${id}`;
  };

  return (
    <div>
      <h1>Sales Statuses</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default SalesStatusList;
